import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { MenuContainer } from "./menu.styled";
import repeat from "assets/images/repeat.svg";
import element from "assets/icons/sidebarMenu/element-plus.svg";
import activeElement from "assets/icons/sidebarMenu/element-plus-active.svg";
import wallet from "assets/icons/sidebarMenu/wallet.svg";
import activeWallet from "assets/icons/sidebarMenu/wallet-active.svg";

export default function MobileMenu() {
  const location = useLocation();

  const [activePath, setActivePath] = useState();
  // location.pathname.replaceAll("/", "")

  useEffect(() => {
    setActivePath(location.pathname.replaceAll("/", ""));
  }, []);

  return (
    <MenuContainer>
      <div className="box">
        <div className="left">
          <Link to="/wallet">
            <img src={activePath === "wallet" ? activeWallet : wallet} />
            <span>کیف پول</span>
          </Link>
        </div>
        <div className="mid">
          <Link className="circle" to="/convert-text-to-speech">
            <img src={repeat} />
            <span>تبدیل متن به گفتار</span>
          </Link>
        </div>
        <div className="right">
          <Link to="/archive">
            {/* <img src={`element-plus${activeBtn === "archive" ? "_active" : ""}.svg`}/> */}
            <img src={activePath === "archive" ? activeElement : element} />
            <span>آرشیو</span>
          </Link>
        </div>
      </div>
    </MenuContainer>
  );
}
